import { render } from "./HeroiconsOutlineMicrophone.vue?vue&type=template&id=2960b3d3"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMicrophone.vue"]])

export default __exports__